import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { TableContainer as DefaultTable } from 'components/DefaultTable/styles';

import colors from 'themes/Main';

const { darkBlue, gray03, pink, warning } = colors;

export const HistoryTable = styled(DefaultTable)`
  .table-responsive {
    min-height: auto;
  }

  tbody tr:hover {
    cursor: default;
    background-color: transparent;
  }
`;

export const TableCallback = styled.div`
  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
  margin: 0 32px;
  padding: 32px;
  border: 1px dashed ${gray03};
  border-radius: 5px;
  opacity: 0.5;

  p {
    text-align: center;
    color: ${gray03};
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0;
  }
`;

export const TestButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const TableTitle = styled.h2`
  margin: 64px 0 16px;
  font-size: 20px;
  color: ${darkBlue};
  line-height: 30px;
  font-weight: 700;
`;

export const RecievedSolicitations = styled(DefaultTable)`
  .table-responsive {
    min-height: 200px;
  }

  thead tr th {
    &:first-child,
    &:nth-child(2) {
      cursor: pointer;
    }

    &:nth-child(4),
    &:last-child {
      text-align: center;
    }

    svg {
      margin-left: 8px;
    }
  }

  tbody tr {
    &:hover {
      cursor: default;
      background-color: transparent;
    }

    td {
      width: 1%;

      &.no-applicable {
        color: ${gray03};
        font-style: italic;
        font-weight: 600;

        &:hover {
          cursor: not-allowed;
        }
      }

      &:nth-child(2) {
        &.type-evaluation {
          color: ${pink};
          font-weight: 700;
        }

        &.type-mediation {
          color: ${warning};
          font-weight: 700;
        }
      }

      &:nth-child(4) {
        text-align: center;

        &:not(.no-applicable) {
          text-decoration: underline;
          color: ${darkBlue};
        }
      }

      &:last-child {
        text-align: center;

        button + button {
          margin-left: 16px;
        }
      }
    }
  }
`;

export const MediationTable = styled(DefaultTable)`
  .table-responsive {
    min-height: 200px;
  }

  thead tr th {
    &:first-child,
    :nth-child(2) {
      cursor: pointer;
    }

    svg {
      margin-left: 8px;
    }
  }

  tbody tr {
    &:hover {
      cursor: default;
      background-color: transparent;
    }

    td {
      &:not(:first-child) {
        width: 30%;
      }

      &:first-child {
        width: 40%;
      }

      &.no-applicable {
        color: ${gray03};
        font-style: italic;
        font-weight: 600;

        &:hover {
          cursor: not-allowed;
        }
      }

      &.andamento {
        color: ${warning};
        font-weight: 700;
      }

      &.aceita {
        font-weight: 700;
        color: ${pink};
      }

      &:first-child {
        width: 30vw;
      }
    }
  }
`;

export const EvaluationTable = styled(MediationTable)``;

export const ActionButton = styled.button`
  outline: 0;
  border: 0;
  background-color: transparent;
  transition: opacity 300ms;

  &.no-icon {
    text-decoration: underline;
    color: ${darkBlue};
  }

  &:hover {
    opacity: 0.45;
  }
`;

export const ActionLink = styled(Link)`
  outline: 0;
  border: 0;
  background-color: transparent;
  transition: opacity 300ms;

  &.no-icon {
    text-decoration: underline;
    color: ${darkBlue};
  }

  &:hover {
    opacity: 0.45;
  }
`;
